import { getMessageFromError } from '../utils/functions'

const PREFIX = 'admin/video'
export default {
  /* -------------------------------------------------------------------------- */
  /*                               Create Audio                               */
  /* -------------------------------------------------------------------------- */
  async create({ commit }, data) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.post(`${PREFIX}/create`, data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      // Manage Error
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                                List Audio                             */
  /* -------------------------------------------------------------------------- */
  async get({ commit }, params) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${PREFIX}/list`, { params })
      if (params.type == 'dropdown') {
        const result = res.data.data.results.map((c) => ({
          value: c._id,
          label: `${c.title} (${c.category || 'No Category'})`
        }))
        return {
          data: result
        }
      } else {
        commit('SET_STATE', {
          action: 'listLoading',
          data: false
        })
        commit('SET_STATE', {
          action: 'records',
          data: res.data.data.results
        })
        commit('SET_STATE', {
          action: 'total',
          data: res.data.data.totalResults
        })
        commit('SET_STATE', {
          action: 'FilteredCount',
          data: res.data.data.totalResults
        })
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Delete Audio                               */
  /* -------------------------------------------------------------------------- */
  async delete({ commit }, id) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.delete(`/${PREFIX}/delete/${id}`)
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Update Audio                               */
  /* -------------------------------------------------------------------------- */
  async update({ commit }, { id, data }) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.put(`${PREFIX}/update/${id}`, data)
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Show Audio                               */
  /* -------------------------------------------------------------------------- */
  async show({ commit }, id) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${PREFIX}/details/${id}`)
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'record',
        data: res.data.data
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },
  /* -------------------------------------------------------------------------- */
  /*                               Update Status                               */
  /* -------------------------------------------------------------------------- */
  async updateStatus({ commit }, { id, data }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.put(`${PREFIX}/manage-status/${id}`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATUS', { id, status: res.data.data.is_active })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  }
}
